<iframe name="collabPageIframe"  class="w-100 border-0" [style.height.px]="iFrameHeight" (load)="iframeLoad($event)" #iframe></iframe>
